import React from 'react';
import { XIcon } from '@phosphor-icons/react';
import { FilterItem } from './FilterList';

interface FilterListItemProps {
    item: FilterItem;
    showRemoveButton?: boolean;
}

export function FilterListItem({
    item,
    showRemoveButton = true,
}: FilterListItemProps) {
    return (
        <div className="flex items-center gap-2">
            <span className="text-sm-medium text-grey-200 truncate flex-1">
                {item.label}
            </span>
            {item.onRemove && showRemoveButton && (
                <button
                    onClick={item.onRemove}
                    className="text-grey-300 hover:text-white-100 transition-colors flex-shrink-0"
                >
                    <XIcon className="w-4 h-4" />
                </button>
            )}
        </div>
    );
}
